/** @jsx jsx */
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Flex, jsx, Text } from 'theme-ui'
import StarIcon from '~/assets/images/icons/star.inline.svg'

const Quote = ({ quote }) => {
  const { author, authorDescription, authorImage, body, starCount } = quote
  return (
    <Flex sx={{ flexDirection: 'column' }}>
      {authorImage && (
        <Box
          mb={-8}
          ml={['auto', null, 3]}
          mr={['auto', null, 0]}
          sx={{
            borderRadius: '50%',
            height: '96px',
            overflow: 'hidden',
            transform: 'translateZ(0)',
            width: '96px',
          }}
        >
          <GatsbyImage
            image={authorImage.gatsbyImageData}
            alt={authorImage.description}
          />
        </Box>
      )}
      <Box
        p={3}
        pb={3}
        pt={authorImage ? 10 : 3}
        sx={{
          backgroundColor: 'white',
          borderRadius: author ? '8px 8px 0 0' : '8px',
          flexGrow: '1',
        }}
      >
        {starCount && (
          <Box mb={1} sx={{ textAlign: ['center', null, 'left'] }}>
            {[...Array(starCount)].map((x, i) => (
              <StarIcon
                key={i}
                sx={{ color: 'brandTertiary', marginRight: '3px' }}
              />
            ))}
          </Box>
        )}
        <Box
          dangerouslySetInnerHTML={{
            __html: body.childMarkdownRemark.html,
          }}
          sx={{
            '& p': {
              m: 0,
              variant: 'text.quote2',
            },
          }}
        />
      </Box>
      {author && (
        <Box p={3} sx={{ backgroundColor: 'backgroundDark' }}>
          <Text as="h3" variant="callout1" mb="4px">
            {author}
          </Text>
          {authorDescription && (
            <Text as="p" color="greyDark" variant="description">
              {authorDescription}
            </Text>
          )}
        </Box>
      )}
    </Flex>
  )
}

Quote.propTypes = {
  quote: PropTypes.shape({
    author: PropTypes.string,
    body: PropTypes.shape({}),
  }),
}

export default Quote
